import {
  CREATE_USER_SUCCESS,
  CREATE_USER_FAIL,
  RETRIEVE_USER_SUCCESS,
  RETRIEVE_USER_FAIL,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
} from "../actions/types";

const initialState = {
  items: [],
  totalItems: 0,
  totalPages: 0,
  currentPage: 0,
};

function userReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CREATE_USER_SUCCESS:
      return {
        ...state,
        items: [...state.items, payload],
      };

    case RETRIEVE_USER_SUCCESS:
      // Check if payload is array (backward compatibility or other actions) or object (pagination)
      if (Array.isArray(payload)) {
        return {
          ...state,
          items: payload,
          totalItems: payload.length,
        };
      } else {
        return {
          items: payload.users,
          totalItems: payload.totalItems,
          totalPages: payload.totalPages,
          currentPage: payload.currentPage,
        };
      }

    case RETRIEVE_USER_FAIL:
      return {
        ...state,
      };

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        items: state.items.map((user) => {
          if (user.uuid === payload.uuid) {
            return {
              ...user,
              ...payload,
            };
          } else {
            return user;
          }
        }),
      };

    case DELETE_USER_SUCCESS:
      return {
        ...state,
        items: state.items.filter(({ uuid }) => uuid !== payload.uuid),
      };

    default:
      return state;
  }
}


export default userReducer;
